{
  "loading": "Yükleniyor...",
  "loadingMore": "Daha fazla yükleniyor..."
}